<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.product") }} V2
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
             <div class="row">
				<div class="col-md-4">
					<base-input
						v-model="searchQuery"
						prepend-icon="fas fa-search"
						:placeholder="$t('search')"
					>
					</base-input>
				</div>
             </div>
          </template>
          <div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
            >
				<el-table-column width="120">
					<div slot-scope="{ row }" class="d-flex">
						<img :src="GetProductUrl(row.Image)" height="80px" v-if="row.Image && (row.Image.includes('.png') || row.Image.includes('.jpg') || row.Image.includes('jpeg'))"/>
					</div>
				</el-table-column>

				<el-table-column :label="$t('wms.product_name')" min-width="150">
					<div slot-scope="{ row }">
						{{ row.Name }}
					</div>
				</el-table-column>

				<el-table-column :label="$t('wms.product_pn')" min-width="100">
					<div slot-scope="{ row }">
						{{ row.ManPN }}
					</div>
				</el-table-column>

				<el-table-column :label="$t('wms.barcode')" min-width="100">
					<div slot-scope="{ row }">
						{{ row.BarCode }}
					</div>
				</el-table-column>

				<el-table-column label="Stock Sync" width="100">
					<div slot-scope="{ row }" class="d-flex justify-content-center">
						<el-switch
							v-model="row.stock_sync_enabled"
							:active-value="1"
							:inactive-value="0"
							active-color="#13ce66"
							inactive-color="#909399"
							@change="handleStockSyncToggle(row)"
						>
						</el-switch>
					</div>
				</el-table-column>

				<el-table-column label="Stock Alarm" width="100">
					<div slot-scope="{ row }" class="d-flex justify-content-center">
						<el-switch
							v-model="row.stock_alarm_enabled"
							:active-value="1"
							:inactive-value="0"
							active-color="#f5365c"
							inactive-color="#909399"
							@change="handleStockAlarmToggle(row)"
						>
						</el-switch>
					</div>
				</el-table-column>

				<el-table-column
					min-width="120px"
					align="right"
					:label="$t('actions')"
				>
					<div slot-scope="{ row }" class="d-flex">
						<base-button
							@click.native="handleSettings(row)"
							class="edit"
							type="info"
							size="sm"
							icon
						>
							<i class="text-white fa fa-cog"></i>
						</base-button>
						<base-button
							@click.native="handleBarcode(row)"
							class="edit"
							type="warning"
							size="sm"
							icon
						>
							<i class="text-dtac-bt fa fa-barcode"></i>
						</base-button>
					</div>
				</el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <!-- Stock Settings Modal -->
    <modal :show.sync="showSettingsModal" modal-classes="modal-secondary">
      <h5 slot="header" class="modal-title">Stock Settings - {{ settingsData.name }}</h5>
      <form class="new-event--form" @submit.prevent="">

        <div class="row">
          <div class="col-md-6">
            <label class="form-control-label">Stock Sync</label>
            <div>
              <el-switch
                v-model="settingsData.stock_sync_enabled"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#909399"
              >
              </el-switch>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-control-label">Stock Alarm</label>
            <div>
              <el-switch
                v-model="settingsData.stock_alarm_enabled"
                :active-value="1"
                :inactive-value="0"
                active-color="#f5365c"
                inactive-color="#909399"
              >
              </el-switch>
            </div>
          </div>
        </div>

        <hr/>

        <div class="row">
          <div class="col-md-6">
            <base-input
              label="Sync Percentage (%)"
              v-model="settingsData.stock_sync_percentage"
              type="number"
              min="0"
              max="100"
            >
            </base-input>
          </div>
          <div class="col-md-6">
            <base-input
              label="Sync Threshold"
              v-model="settingsData.stock_sync_threshold"
              type="number"
              min="0"
            >
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <base-input
              label="Alarm Threshold"
              v-model="settingsData.stock_alarm_threshold"
              type="number"
              min="0"
            >
            </base-input>
          </div>
        </div>

      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleSaveSettings()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showSettingsModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Switch } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Switch.name]: Switch,
  },
  computed: {
    ...mapGetters({
      tableData: "WmsProduct/getData",
    }),
  },
  data() {
    return {
      propsToSearch: ["Name", "BarCode", "ManPN"],
      showSettingsModal: false,
      settingsData: {
        id: 0,
        name: "",
        stock_sync_enabled: 0,
        stock_sync_percentage: 100,
        stock_sync_threshold: 0,
        stock_alarm_enabled: 0,
        stock_alarm_threshold: 0,
      },
    };
  },
  mounted() {
    this.listDataV3();
  },
  methods: {
    ...mapActions({
      listDataV3: "WmsProduct/listDataV3",
      toggleStockSync: "WmsProduct/toggleStockSync",
      toggleStockAlarm: "WmsProduct/toggleStockAlarm",
      updateStockSettings: "WmsProduct/updateStockSettings",
      getBarcode: "WmsProduct/getBarcode",
    }),
    handleStockSyncToggle(row) {
      this.toggleStockSync({
        id: row.ID,
        payload: { StockSyncEnabled: row.stock_sync_enabled }
      })
      .then(function(resp) {
        swal.fire({
          title: "Success",
          text: "Stock sync " + (row.stock_sync_enabled ? "enabled" : "disabled"),
          icon: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      })
      .catch(function(err) {
        // Revert the toggle on error
        row.stock_sync_enabled = row.stock_sync_enabled ? 0 : 1;
        var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? err.response.data.Msg : "error";
        swal.fire({
          title: errorMsg,
          text: "",
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
      });
    },
    handleStockAlarmToggle(row) {
      this.toggleStockAlarm({
        id: row.ID,
        payload: { StockAlarmEnabled: row.stock_alarm_enabled }
      })
      .then(function(resp) {
        swal.fire({
          title: "Success",
          text: "Stock alarm " + (row.stock_alarm_enabled ? "enabled" : "disabled"),
          icon: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      })
      .catch(function(err) {
        // Revert the toggle on error
        row.stock_alarm_enabled = row.stock_alarm_enabled ? 0 : 1;
        var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? err.response.data.Msg : "error";
        swal.fire({
          title: errorMsg,
          text: "",
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
      });
    },
    handleSettings(row) {
      this.settingsData.id = row.ID;
      this.settingsData.name = row.Name;
      this.settingsData.stock_sync_enabled = row.stock_sync_enabled || 0;
      this.settingsData.stock_sync_percentage = row.stock_sync_percentage || 100;
      this.settingsData.stock_sync_threshold = row.stock_sync_threshold || 0;
      this.settingsData.stock_alarm_enabled = row.stock_alarm_enabled || 0;
      this.settingsData.stock_alarm_threshold = row.stock_alarm_threshold || 0;
      this.showSettingsModal = true;
    },
    handleSaveSettings() {
      var self = this;
      this.updateStockSettings({
        id: this.settingsData.id,
        payload: {
          StockSyncEnabled: parseInt(this.settingsData.stock_sync_enabled),
          StockSyncPercentage: parseInt(this.settingsData.stock_sync_percentage),
          StockSyncThreshold: parseInt(this.settingsData.stock_sync_threshold),
          StockAlarmEnabled: parseInt(this.settingsData.stock_alarm_enabled),
          StockAlarmThreshold: parseInt(this.settingsData.stock_alarm_threshold)
        }
      })
      .then(function(resp) {
        self.showSettingsModal = false;
        self.listDataV3();
        swal.fire({
          title: self.$t("edit_success"),
          text: "",
          icon: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      })
      .catch(function(err) {
        var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? err.response.data.Msg : "error";
        swal.fire({
          title: errorMsg,
          text: "",
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false
        });
      });
    },
    handleBarcode(row) {
      this.getBarcode({
        barcode: row.BarCode,
        type: "base64",
      })
      .then(function(resp) {
        swal.fire({
          title: row.Name,
          html: '<img src="' + resp.data + '">' + row.BarCode,
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
      })
      .catch(function(err) {
        swal.fire({
          title: "Barcode Error",
          text: "Barcode : " + row.BarCode,
          icon: "error",
          confirmButtonClass: "btn btn-danger btn-fill",
          buttonsStyling: false,
        });
      });
    },
    GetProductUrl(filename) {
      if (!filename) return "";
      return process.env.VUE_APP_API_BASE_URL + "/files/wms_products/" + filename;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
